import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import Spinner from "components/common/Spinner";
import AvailabilityTable from "components/menu/profile/availabilityTable";
import {
    profileGetGeneralAvailability,
    profileSetGeneralAvailability
} from "api/menu/profile/actions";
const TabGeneralAvailability = (props) => {
    const timeFormat = "h:mm A";

    const {
        setUnsaved,
        generalAvailability,
        profileGetGeneralAvailability,
        profileSetGeneralAvailability,
        loading,

    } = props;

    const simpleValidator = useRef(new SimpleReactValidator({
        locale: "en",
        element: message => <div className="text-danger">{message}</div>
    }));

    const [userGeneralAvailability, setUserGeneralAvailability] = useState(generalAvailability);

    const handleSave = (data) => {
        if (simpleValidator.current.allValid()) {
            profileSetGeneralAvailability(data);
            setUnsaved(false);
        }
    };

    const onChange = (arr) => {
            const newUserGeneralAvailability = Object.assign({}, userGeneralAvailability);
            arr.forEach(item => {
                newUserGeneralAvailability[item.key] = item.value;
            });
            setUserGeneralAvailability(newUserGeneralAvailability);
            setUnsaved(() => handleSave(newUserGeneralAvailability));
        },
        onChangeTime = (dayOfWeek, key, time) => {
            const newUserGeneralAvailability = Object.assign({}, userGeneralAvailability);
            newUserGeneralAvailability.dailyAvailabilities =
                Object.assign({}, newUserGeneralAvailability.dailyAvailabilities);
            newUserGeneralAvailability.dailyAvailabilities[dayOfWeek][key] = time
                ? moment(time).format(timeFormat)
                : null;
            setUserGeneralAvailability(newUserGeneralAvailability);
            setUnsaved(() => handleSave(newUserGeneralAvailability));
        },
        onChangeHours = (dayOfWeek, key, hours) => {
            const newUserGeneralAvailability = Object.assign({}, userGeneralAvailability);
            newUserGeneralAvailability.dailyAvailabilities =
                Object.assign({}, newUserGeneralAvailability.dailyAvailabilities);

            /*
            newUserGeneralAvailability.dailyAvailabilities[dayOfWeek][key] = hours
                ? timeStringToFloat(moment(hours).format("H:mm"))
                : null;
                */
            newUserGeneralAvailability.dailyAvailabilities[dayOfWeek][key] = hours;
            setUserGeneralAvailability(newUserGeneralAvailability);
            setUnsaved(() => handleSave(newUserGeneralAvailability));
        };

    useEffect(() => {
        profileGetGeneralAvailability();
    }, [profileGetGeneralAvailability]);

    useEffect(() => {
        setUserGeneralAvailability(generalAvailability);
    }, [generalAvailability]);
    return (
        <div className="position-relative py-4">
            {!loading || <Spinner />}

            <div className="mt-4 mb-2">
                In a typical week what would your hours of availability be each day of the week?
            </div>

            <div className="row">
                <div className="col-8">
                    <AvailabilityTable
                        data={(userGeneralAvailability.dailyAvailabilities || {})}
                        onChangeHours={onChangeHours}
                        onChangeTime={onChangeTime}
                    />
                </div>
                <div className="col-4">
                    <div className="mt-4 mb-2">
                        On weekly basis I'd like to work:
                    </div>
                    <div className="form-group form-inline">
                        <label>Minimum</label>
                        <input
                            className="form-control mx-2"
                            type="number"
                            value={userGeneralAvailability.weeklyHoursMinimum || 0}
                            onChange={ev => {
                                onChange([{
                                    key: "weeklyHoursMinimum",
                                    value: ev.target.value
                                }]);
                            }}
                        />
                        <label>Hours</label>
                    </div>
                    <div className="form-group form-inline">
                        <label>Maximum</label>
                        <input
                            className="form-control mx-2"
                            type="number"
                            value={userGeneralAvailability.weeklyHoursMaximum || 0}
                            onChange={ev => {
                                onChange([{
                                    key: "weeklyHoursMaximum",
                                    value: ev.target.value
                                }]);
                            }}
                        />
                        <label>Hours</label>
                    </div>

                    <div className="mt-5 mb-2">
                        Ideally I'd like to work
                    </div>
                    <div className="form-group form-inline">
                        <input
                            className="form-control mr-2"
                            type="number"
                            value={userGeneralAvailability.weeklyHoursPreferred || 0}
                            onChange={ev => {
                                onChange([{
                                    key: "weeklyHoursPreferred",
                                    value: ev.target.value
                                }]);
                            }}
                        />
                        <label>hours on a weekly basis</label>
                    </div>
                </div>
            </div>

            <div className="text-right">
                <button
                    className="btn btn-success"
                    onClick={() => handleSave(userGeneralAvailability)}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    loading: state.profile.loading,
    generalAvailability: state.profile.generalAvailability,
});

const mapStateToDispatch = dispatch => ({
    profileGetGeneralAvailability: bindActionCreators(profileGetGeneralAvailability, dispatch),
    profileSetGeneralAvailability: bindActionCreators(profileSetGeneralAvailability, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TabGeneralAvailability);
